var asciiToArray=require('./_asciiToArray'),hasUnicode=require('./_hasUnicode'),unicodeToArray=require('./_unicodeToArray');/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}module.exports=stringToArray;